var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "basic-information" },
    [
      _c(
        "el-form",
        {
          ref: "basicForm",
          attrs: {
            id: "basicForm",
            model: _vm.basicForm,
            "label-width": "85px",
            rules: _vm.rulesBasicForm,
            size: "small",
          },
        },
        [
          _c("h3", [_vm._v("基础信息")]),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.rQueryObj.type === "group" ? "分群名" : "标签名",
                prop: "name",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "text",
                  placeholder: "请输入名称",
                  maxlength: "30",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.basicForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.basicForm, "name", $$v)
                  },
                  expression: "basicForm.name",
                },
              }),
            ],
            1
          ),
          _vm.rQueryObj.type !== "group"
            ? _c(
                "el-form-item",
                { attrs: { label: "分类", prop: "tagClassifyId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择分类",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.basicForm.tagClassifyId,
                        callback: function ($$v) {
                          _vm.$set(_vm.basicForm, "tagClassifyId", $$v)
                        },
                        expression: "basicForm.tagClassifyId",
                      },
                    },
                    _vm._l(_vm.tagClassifyDataList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "公司部门", prop: "orgCodes" } },
            [
              _c("el-cascader", {
                attrs: {
                  options: _vm.orgCodesList,
                  props: {
                    label: "orgName",
                    value: "orgCode",
                    children: "children",
                    multiple: true,
                    checkStrictly: true,
                  },
                  placeholder: "请选择公司部门",
                  "show-all-levels": false,
                  clearable: "",
                },
                on: { change: _vm.onChangeOrgCode },
                model: {
                  value: _vm.basicForm.orgCodes,
                  callback: function ($$v) {
                    _vm.$set(_vm.basicForm, "orgCodes", $$v)
                  },
                  expression: "basicForm.orgCodes",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "remark" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 5,
                  placeholder: "请输入备注",
                  maxlength: "200",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.basicForm.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.basicForm, "remark", $$v)
                  },
                  expression: "basicForm.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }